import { Component, Input, OnChanges, Output, EventEmitter, SimpleChanges, OnInit } from '@angular/core';
import { ListBoxItem } from './ListBoxItem';
import { ILabel } from '../ILabel.model';
import { ActivatedRoute } from '@angular/router';
import { contains } from '../common/functions/js-linq';

@Component({
    selector: 'cpq-list-box',
    templateUrl: './cpq-list-box.component.html',
    styleUrls: ['./cpq-list-box.component.scss'],
    standalone: false
})

export class CpqListBoxComponent implements OnChanges {
    @Input() selectedItems = new Array<number>();
    @Output() selectedItemsChange = new EventEmitter<Array<number>>();

    @Input('items') items: Array<ListBoxItem>;
    @Input('isMultiSelect') isMultiSelect = true;
    @Input('hasSearch') hasSearch = false;
    @Input('searchLabel') searchLabel?: ILabel;
    @Input('labelLink') labelLink?: ILabel;
    @Input('displayCheckMarkOnSelectedItems') displayCheckMark = true;

    @Output('onSelect') onSelect = new EventEmitter<ListBoxItem>();
    @Output('linkAction') linkAction?: EventEmitter<any> = new EventEmitter<any>();

    public searchKeywordAvailable: string;
    public lastSelectedIndex: number = 1;
    public isShiftKeyUsedForPreviousSelection: boolean = false;
    public isCtrlKeyUsedForPreviousSelection: boolean = false;

    constructor(public route: ActivatedRoute) {
    }

    ngOnChanges(changes: SimpleChanges): void {
        document.getSelection().removeAllRanges();

        if (changes.items) {
            this.items = changes.items.currentValue;

            // if we did not set visibility state set it to visible
            if (this.items) {
                this.items.filter(element => element.isVisible === undefined)
                    .forEach(element => { element.isVisible = true; });
            }
        }

        if (changes.selectedItems) {
            this.selectedItems = changes.selectedItems.currentValue;
        }

        if (this.selectedItems && this.items) {
            this.items.forEach(element => {
                element.selected = contains(this.selectedItems, x => x === element.id);
            });
        }
    }

    public selectedItem(selectedItem: ListBoxItem, event: MouseEvent) {
        document.getSelection().removeAllRanges();

        if (selectedItem.isReadOnly) {
            return;
        }

        this.selectedItems = [];
        if (!this.isMultiSelect) {
            selectedItem.selected = !selectedItem.selected;
            this.onSelect.emit(selectedItem);

            this.items.filter(item => item.id !== selectedItem.id).forEach(filteredItem => filteredItem.selected = false);

            if (selectedItem.selected) {
                this.selectedItems.push(selectedItem.id);
            }
        } else {
            if (event.shiftKey) {
                this.selectRange(selectedItem);
            }
            else if (event.ctrlKey) {
                this.selectSingleItemByHoldingCtrl(selectedItem);                
            }
            else {
                this.selectSingleItem(selectedItem);
            }
        }

        this.selectedItemsChange.emit(this.selectedItems);
    }

    selectRange(selectedItem: ListBoxItem) {
        this.isShiftKeyUsedForPreviousSelection = true;

        const selectedIndex = this.items.indexOf(selectedItem);

        if(this.lastSelectedIndex < selectedIndex){
            this.items.filter((item, index) => index >= this.lastSelectedIndex && index <= selectedIndex && item.isVisible).forEach(filteredItem => {
                filteredItem.selected = true;
                this.selectedItems.push(filteredItem.id);

                if(this.items.indexOf(filteredItem) != this.lastSelectedIndex) {
                    this.onSelect.emit(filteredItem);
                }
            });
        }
        else {
            this.items.filter((item, index) => index >= selectedIndex && index <= this.lastSelectedIndex && item.isVisible).forEach(filteredItem => {
                filteredItem.selected = true;
                this.selectedItems.push(filteredItem.id);

                if(this.items.indexOf(filteredItem) != this.lastSelectedIndex) {
                    this.onSelect.emit(filteredItem);
                }
            });
        }
    }

    selectSingleItemByHoldingCtrl(selectedItem: ListBoxItem) {
        this.isCtrlKeyUsedForPreviousSelection = true;

        selectedItem.selected = !selectedItem.selected;
        this.lastSelectedIndex = this.items.indexOf(selectedItem);

        this.items.filter(item => item.selected).forEach(filteredItem => this.selectedItems.push(filteredItem.id));

        this.onSelect.emit(selectedItem);
    }

    selectSingleItem(selectedItem: ListBoxItem) {
        if(this.isShiftKeyUsedForPreviousSelection || this.isCtrlKeyUsedForPreviousSelection) {
            this.deselectAll();
        }

        selectedItem.selected = !selectedItem.selected;
        this.lastSelectedIndex = this.items.indexOf(selectedItem);

        this.items.filter(item => item.selected).forEach(filteredItem => this.selectedItems.push(filteredItem.id));

        this.onSelect.emit(selectedItem);
    }

    deselectAll() {
        this.items.filter(item => item.selected).forEach(filteredItem => {
            filteredItem.selected = false;
            this.onSelect.emit(filteredItem)
        });

        this.isShiftKeyUsedForPreviousSelection = false;
        this.isCtrlKeyUsedForPreviousSelection = false;
        this.selectedItems = new Array<number>();
    }

    searchAvailable() {
        this.items.forEach(item => { item.isVisible = true; });

        if (this.searchKeywordAvailable !== '') {
            this.items.forEach(item =>
                item.isVisible = item.text.toLocaleLowerCase().indexOf(this.searchKeywordAvailable.toLocaleLowerCase()) > -1
            );
        }
    }

    onLinkClick(event) {
        this.linkAction.emit([event]);
    }
}